export class AccountingNewEntity {
    reportId = "";
    constructor(props, id) {
        this.props = props;
        this._id = id;
    }

    static restore(props) {
        const accountingNewEntity = new AccountingNewEntity(props, props._id);
        accountingNewEntity.setRedirectByNotificationCode();
        accountingNewEntity.setDateCreatedAt();
        accountingNewEntity.reportId = accountingNewEntity.getReportId();
        return accountingNewEntity;
    }

    setDateCreatedAt() {
        this.props.createdAt = new Date(this.props.createdAt);
    }

    setRedirectByNotificationCode() {
        const news = {
            1: {
                label:
                    "Há dados desatualizados na integração Dominio. Acesse integrações para atualizar",
                uiSref: [
                    "nucont.accounting.integration.dominioideen",
                    {
                        source: "contabil"
                    }
                ]
            },
            2: {
                label:
                    "Há dados desatualizados na integração Conta Azul. Acesse integrações para atualizar",
                uiSref: [
                    "nucont.accounting.integration.contaazul",
                    {
                        source: "financeiro"
                    }
                ]
            },
            3: {
                label:
                    "Há dados desatualizados na integração Omie. Acesse integrações para atualizar",
                uiSref: [
                    "nucont.accounting.integration.omie",
                    {
                        source: "financeiro"
                    }
                ]
            },
            4: {
                label:
                    "Há dados desatualizados na integração Nibo. Acesse integrações para atualizar",
                uiSref: [
                    "nucont.accounting.integration.nibo",
                    {
                        source: "financeiro"
                    }
                ]
            },
            5: {
                label:
                    "Há empresas conectadas que precisam ser parametrizadas. Para parametrizar, acesse a empresa",
                uiSref: [
                    "nucont.accounting.overview.portfolio.companies.data",
                    {
                        filterCompany: {
                            value: "sourceAccounting",
                            filter: ["needParametrize"]
                        }
                    }
                ]
            },
            6: {
                label: "Integração PGDAS disponível. Acesse Integrações",
                uiSref: [
                    "nucont.accounting.integration.serpro",
                    {
                        source: "fiscal"
                    }
                ]
            },
            7: {
                label: "Cadastre seu time em Gestão de Usuário",
                uiSref: ["nucont.accounting.manager-users.employee"]
            },
            8: {
                label:
                    "Há empresas sem contato/destinatário cadastrado. Cadastre-os em Gestão de Contatos",
                uiSref: ["nucont.accounting.contactsManagment.companies"]
            },
            9: {
                label:
                    "Há empresas integradas sem conexão. Desta forma, não haverá atualização de dados. Acesse Integrações.",
                uiSref: ["nucont.accounting.integrations"]
            },
            10: {
                label:
                    "Ative o Piloto Automático para automatizar a geração e o envio dos Dashes. Acesse Automações.",
                uiSref: ["nucont.accounting.reporting-center.automations"]
            }
        };

        if (news[this.props?.notificationCode])
            this.props.link = news[this.props?.notificationCode];
    }

    getReportId() {
        if ([99, 115].includes(this.props?.notificationCode)) {
            const params = new URL(this?.props?.options?.link).searchParams;
            return params.get("reportId");
        }
    }
}
